export default Buffer.from("AuBSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TRQABAIF/cBgBAL54AL56AL9/AMAEE759Cb8cAL96Ab5UAL97Ab5WAL98AL5lAr5YAb99AcAAAb1bAL1WAMACAL5jAr5bAMADGb8wCMAFAL9XYANhEMAOAAC+eQAEwB8=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/WP-Symbol.bcmap
// module id = 734
// module chunks = 502